const difficulty_options = [
  { label: "Łatwe", value: "easy" },
  { label: "Trudne", value: "difficult" },
];

export default difficulty_options;
